import axiosInstance from "../utils/axios";
import { URL } from "../utils/axios";

const API_URL = `${URL}/api/hoa`;

// Fetch all hoa
export const fetchHoas = async () => {
  try {
    const response = await axiosInstance.get(API_URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Fetch hoa by id
export const fetchHoaById = async (hoaId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/${hoaId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Create a new hoa
export const createHoa = async (hoaData) => {
  try {
    const formData = new FormData();
    formData.append("title", hoaData.title);
    if (hoaData.files) {
      formData.append("files", hoaData.files);
    }
    const response = await axiosInstance.post(API_URL, formData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update an hoa
export const updateHoa = async ({ hoaId, hoaData }) => {
  try {
    const formData = new FormData();
    if (hoaData.title) {
      formData.append("title", hoaData.title);
    }
    if (hoaData.file) {
      formData.append("file", hoaData.file);
    }
    const response = await axiosInstance.put(`${API_URL}/${hoaId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete an hoa
export const deleteHoa = async (hoaId) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/${hoaId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};